
<template>
  <v-dialog v-model="dialog" width="450">
    <v-card>
      <v-toolbar dark color="primary" class="formHeader">
        <v-toolbar-title>{{ $t('views.Login.forgotPassword.title') }}</v-toolbar-title>
      </v-toolbar>
      <v-card-text class="mt-8">
        {{
          emailSent
            ? $t('views.Login.forgotPassword.sentMessage')
            : $t('views.Login.forgotPassword.message')
        }}
      </v-card-text>
      <v-card-text>
        <v-text-field
          prepend-icon="person"
          name="email"
          ref="email"
          :label="$t('views.Login.email')"
          :rules="emailRules"
          v-model="email"
          @keydown.enter="clickSend"
          type="text"
          class="pr-8"
        />
      </v-card-text>
      <v-card-actions>
        <v-card-text v-if="emailSent" class="emailSent">
          {{ $t('views.Login.forgotPassword.emailSent') }}
        </v-card-text>
        <v-spacer />
        <v-btn
          color="primary"
          class="mr-2"
          :disabled="invalidEmail()"
          @click="clickSend"
          @keydown.enter="clickSend"
        >
          {{
            emailSent
              ? $t('views.Login.forgotPassword.resendEmail')
              : $t('views.Login.forgotPassword.sendEmail')
          }}
        </v-btn>
        <v-btn
          ref="closeButton"
          color="primary"
          class="mr-2"
          @click="dialog = false"
        >
          {{ $t('views.Login.forgotPassword.close') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { types } from '../store/rootTypes';

export default {
  name: 'PasswordResetDialog',
  data() {
    return {
      email: '',
      emailSent: false,
      dialog: false,
      emailRules: [v => /.+@.+/.test(v) || this.$t('views.Login.forgotPassword.invalidEmail')],
    };
  },
  computed: {
    ...mapGetters({
      isAuthenticated: types.authentication.getters.isAuthenticated,
    }),
  },
  methods: {
    ...mapActions({
      sendPasswordReset: types.authentication.actions.sendPasswordReset,
    }),
    open() {
      this.dialog = true;
      setTimeout(() => { this.$refs.email.focus(); }, 200);
    },
    invalidEmail() {
      if (this.$refs.email) {
        return !this.$refs.email.valid;
      }
      return true;
    },
    async clickSend() {
      if (this.invalidEmail()) return;

      this.emailSent = true;
      this.$refs.email.blur();
      await this.sendPasswordReset({ email: this.email });
    },
  },
  watch: {
    email() {
      if (this.emailSent) this.emailSent = false;
    },
  },
};
</script>

<style scoped>
.formHeader {
  height: 15%;
}
.emailSent {
  font-weight: 500;
}
</style>
